import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";


// function EducationCards(props) {
//     return (
//       <Card className="project-card-view">
//         <Card.Body>
//           <Card.Title>{props.title}</Card.Title>
//           <Card.Text style={{ textAlign: "justify" }}>
//             {props.description}
//           </Card.Text>

//           {"\n"}
//           {"\n"}
//         </Card.Body>
//       </Card>
//     );
//   }

//   export default EducationCards;


function EducationCards(props) {
    return (
      <Card
        as="a"
        href={props.link}
        target="_blank"
        rel="noreferrer"
        style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }}
        className="project-card-view"
      >
        <Card.Body>
          <Card.Title>{props.title}</Card.Title>
          <Card.Text style={{ textAlign: "justify" }}>
            {props.description}
          </Card.Text>
        </Card.Body>
      </Card>
    );
  }
  export default EducationCards;